export default {
	header: 'Historie úkolu / příležitosti',
	dateOfChange: 'Datum změny',
	nameChange: 'Změnu provedl',
	description: 'Popis',
	originalValue: 'Původní hodnota',
	newValue: 'Nová hodnota',
};
